import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Card,
  DatePicker,
  Tag,
  Input,
  Table,
  Drawer,
  Empty,
  Form,
  Space,
  Select,
  Tooltip,
} from "antd";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  CloseCircleOutlined,
  PlusCircleOutlined,
  CheckCircleOutlined,
  EditOutlined,
  FilePdfFilled,
  FilePdfOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import dayjs from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  GetClientsByPartnerClientId,
  GetPartnerClientByIdApi,
  GetWorkOrderPdfApi,
  GetWorkOrdersListByClientId,
  GetWorkOrdersListByPartnerId,
  getWorkOrdersListByProjectId,
} from "../ClientsApi";
import { resetWorkOrderDetails } from "../ClientsSlice";
import OpenNotificationWithIcon from "CommonComponents/ResultNotification/Notification";
import CreateQuote from "features/Dashboard/CreateQuote";
function WorkOrders(props) {
  const { Search } = Input;
  const { Column } = Table;
  const { RangePicker } = DatePicker;
  const navigate = useNavigate();
  const { companyId, clientId, partnerId, projectId } = useParams();
  const client = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const intl = useIntl();
  const dispatch = useDispatch();
  const workOrdersData = useSelector((state) => state.clients.workOrdersList);
  const totalPages = useSelector((state) => state.clients.totalPages);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const selectedLanguage = localStorage.getItem("selectedlanguage");
  const [open, setOpen] = useState(false);
  const [openQuoteModel, setOpenQuoteModel] = useState(false);
  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };
  const pagination = {
    pageNo: currentPage,
    pageSize: 10,
    searchQuery: searchTerm,
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };
  const statusLabels = {
    13: { statusEn: "Not Started", statusFr: "Non démarré", color: "gray" },
    14: { statusEn: "In Progress", statusFr: "En cours", color: "blue" },
    15: { statusEn: "On Hold", statusFr: "En attente", color: "orange" },
    16: { statusEn: "Completed", statusFr: "Complété", color: "green" },
    17: { statusEn: "Closed", statusFr: "Fermé", color: "darkred" },
  };

  const handleEditClick = (workorderId) => {
    navigate(
      partnerId && clientId
        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/${workorderId}/editworkorder`
        : clientId
        ? `/${companyId}/${clientId}/client_details/${workorderId}/editworkorder`
        : `/${companyId}/${partnerId}/partner_client_details/${workorderId}/editworkorder`
    );
  };
  const handlePrint = async (WorkOrder) => {
    try {
      await Promise.all([
        dispatch(GetWorkOrderPdfApi(WorkOrder.id)).then((response) => {
          if (response) {
            const base64 = response?.value?.pdfBase64;
            const fileName = `${WorkOrder.woNumber}.pdf`;
            const pdfDataUrl = `data:application/pdf;base64,${base64}`;
            const pdfWindow = window.open("", "_blank");
            if (pdfWindow) {
              pdfWindow.document.write(`
              <html>
                  <head><title>${fileName}</title></head>
                  <body style="margin:0">
                    <iframe width="100%" height="100%" src="${pdfDataUrl}" frameborder="0"></iframe>
                  </body>
              </html>
            `);
              pdfWindow.document.close();
            }
          }
        }),
      ]);
    } catch (e) {
      console.error("Error previewing PDF:", e);
    }
  };
  const handleAddWorkOrder = () => {
    const address =
      clientId && client?.address?.length > 0
        ? client.address[0]
        : partnerId && partner?.address?.length > 0
        ? partner.address[0]
        : null;

    const hasValidAddress =
      address &&
      (address.address1?.trim() ||
        address.address2?.trim() ||
        address.city?.trim() ||
        address.zip?.trim() ||
        address.provinceName?.trim() ||
        address.countryName?.trim() ||
        address.countryId ||
        address.provinceId);

    if (!hasValidAddress) {
      OpenNotificationWithIcon(
        "warning",
        "Common.Warning",
        "",
        "LeadView.AddressRequiredWO"
      );
      return;
    }
    if (partnerId && clientId == null) {
      setOpenQuoteModel(true);
      dispatch(GetPartnerClientByIdApi(partnerId));
    } else {
      const targetUrl =
        partnerId && clientId
          ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/addworkorder`
          : clientId
          ? `/${companyId}/${clientId}/client_details/addworkorder`
          : `/${companyId}/${partnerId}/partner_client_details/addworkorder`;

      navigate(targetUrl, {
        state: {
          projectId: props.projectId || null,
        },
      });
    }
  };
  useEffect(() => {
    if (props.projectId) {
      const searchParams = {
        pageNo: null,
        pageSize: null,
        searchQuery: searchTerm,
      };
      dispatch(getWorkOrdersListByProjectId(searchParams, props.projectId));
    } else if (clientId) {
      dispatch(GetWorkOrdersListByClientId(pagination, clientId));
    } else if (partnerId) {
      dispatch(GetWorkOrdersListByPartnerId(pagination, partnerId));
    }
  }, [props.projectId, clientId, partnerId, dispatch, currentPage, searchTerm]);

  useEffect(() => {
    dispatch(resetWorkOrderDetails());
  }, []);

  return (
    <>
      <Row align="middle">
        <Col xs={24} sm={8} md={8} lg={8} xl={8}>
          <Search
            placeholder={intl.formatMessage({
              id: "WorkOrderDetails.PlaceHolder.Search",
            })}
            onSearch={handleSearch}
            allowClear
          />
        </Col>
        <Col
          xs={24}
          sm={16}
          md={16}
          lg={16}
          xl={16}
          className="text-right sm-md-10"
        >
          {/* <Button type="primary" onClick={showDrawer}>
            <PlusCircleOutlined />
            Create WO
          </Button> */}
          <Space>
            {(partnerId && clientId
              ? partner?.isActive && client?.isActive
              : partnerId
              ? partner?.isActive
              : client?.isActive) && (
              <Button type="primary" onClick={handleAddWorkOrder}>
                <PlusCircleOutlined />
                <FormattedMessage id="WorkOrder.AddWorkOrder" />
              </Button>
            )}
          </Space>
        </Col>
      </Row>
      <Table
        dataSource={workOrdersData}
        pagination={{
          current: currentPage,
          total: totalPages * 10,
          showSizeChanger: false,
          onChange: handlePageChange,
        }}
        scroll={{
          x: 900,
        }}
        className="mt-10"
        bordered
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description={intl.formatMessage({
                id: "NoData",
              })}
            />
          ),
        }}
      >
        <Column
          title={<FormattedMessage id="WorkOrder.WoNo" />}
          key="wONumber"
          render={(_, record) => (
            <Link
              to={
                partnerId && clientId
                  ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/${projectId}/projects/wo_details/${record.id}`
                  : clientId
                  ? `/${companyId}/${clientId}/client_details/wo_details/${record.id}`
                  : `/${companyId}/${partnerId}/partner_client_details/wo_details/${record.id}`
              }
            >
              {record.woNumber}
            </Link>
          )}
        />

        <Column
          title={<FormattedMessage id="WorkOrder.StartDate" />}
          key="date"
          render={(_, record) =>
            dayjs(record.contractStartDate).format("YYYY-MM-DD")
          }
        />

        <Column
          title={<FormattedMessage id="WorkOrder.EstimateReference" />}
          key="estimateReference"
          render={(_, record) => record.estimateReference}
        />

        <Column
          title={<FormattedMessage id="WorkOrder.Status" />}
          key="status"
          render={(_, record) => {
            const status = statusLabels[record.statusId] || {
              statusEn: "Unknown",
              statusFr: "Inconnu",
              color: "default",
            };
            const statusText =
              selectedLanguage === "fr-FR" ? status.statusFr : status.statusEn;

            return <Tag color={status.color}>{statusText}</Tag>;
          }}
        />

        <Column
          title={<FormattedMessage id="ClientDetails.Action" />}
          key="action"
          render={(_, record) => {
            const disableEdit = record.estimateReference != null;
            return (
              <Space size="middle">
                <Tooltip
                  title={
                    disableEdit ? (
                      <FormattedMessage id="WorkOrder.WorkOrderCannotBeEdited" />
                    ) : (
                      <FormattedMessage id="Common.Edit" />
                    )
                  }
                >
                  <span>
                    <Button
                      size="small"
                      disabled={disableEdit}
                      onClick={() =>
                        !disableEdit && handleEditClick(record?.id)
                      }
                    >
                      <EditOutlined />
                    </Button>
                  </span>
                </Tooltip>

                <Tooltip
                  title={<FormattedMessage id="ClientDetails.Preview" />}
                >
                  <Button onClick={() => handlePrint(record)} size="small">
                    <FilePdfOutlined />
                  </Button>
                </Tooltip>
              </Space>
            );
          }}
        />

        {/* <Column
            title="Action"
            key="action"
            render={(_, record) => (
              <Space size="middle">
                <Button size="small">
                  <EditOutlined />
                </Button>
              </Space>
            )}
          /> */}
      </Table>
      <Drawer
        title="Create Work Order"
        width={600}
        closable={{ "aria-label": "Close Button" }}
        onClose={onClose}
        open={open}
      >
        <Form
          // form={form}
          name="basic"
          layout="vertical"
          // initialValues={{ formInitialvalues }}
          autoComplete="off"
          size="large"
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Emergency Type"
                name="emergencytype"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder="Select emergency type"
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: "Breakdown",
                      label: "Breakdown",
                    },
                    { value: "Callback", label: "Callback" },
                    { value: "Critical Support", label: "Critical Support" },
                  ]}
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Item
                label="WO Date"
                name="estimateDate"
                rules={[
                  {
                    required: true,
                    message: intl.formatMessage({
                      id: "AddEstimate.error.PleaseSelectTheEstimateDate",
                    }),
                  },
                ]}
              >
                <DatePicker placeholder="WO Date" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={12}>
              <Form.Item
                label="Service Charge"
                name="Service Charge"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Service Charge" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Assigned To"
                name="assignto"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder="Select assign to"
                  style={{ width: "100%" }}
                  options={[
                    {
                      value: "Prudhvi Raj",
                      label: "Prudhvi Raj",
                    },
                    { value: "Vamshi", label: "Vamshi" },
                    { value: "Dinesh", label: "Dinesh" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={24}
              lg={24}
              xl={24}
              className="estimate-quill"
            >
              <Form.Item
                label="Quick Problem Description"
                name="termsAndConditions"
              >
                <ReactQuill theme="snow" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24} className="text-center mt-10">
              <Space>
                <Button danger variant="outlined" size="medium">
                  <CloseCircleOutlined />
                  {<FormattedMessage id="AddClient.Cancel" />}
                </Button>
                <Button type="primary" size="medium" htmlType="submit">
                  <CheckCircleOutlined />
                  <FormattedMessage id="WorkOrder.AddWorkOrder" />
                </Button>
              </Space>
            </Col>
          </Row>
        </Form>
      </Drawer>
      {openQuoteModel && (
        <CreateQuote
          open={openQuoteModel}
          onCancel={() => setOpenQuoteModel(false)}
          partnerId={partnerId}
          type="workorder"
        />
      )}
    </>
  );
}

export default WorkOrders;
